export default __webpack_public_path__ + "static/media/information-white.dd92b8f8.svg";